export default "__VITE_ASSET__DjtoPnPu__"